import React, { useContext } from 'react';
import { componentService } from 'js/services/component.service';
import { usePortletConfig, withPortlet } from 'js/components/system/Portlet';
import { WebContent as WebContentCommon } from 'js/components/system/WebContent';
import { PageContext } from 'js/components/system/Page/store/context';

import { WEB_CONTENT } from './constants';

export const WebContentBare = () => {
    const { addLoadingPromise } = useContext(PageContext);
    const { id: wcId } = usePortletConfig();

    return <WebContentCommon id={wcId} addLoadingPromise={addLoadingPromise} />;
};

export const WebContent = withPortlet()(WebContentBare);

componentService.registerPageComponents({ [WEB_CONTENT]: WebContent });
